import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  AsesmenPendingDpjpRow,
  DashboardDokterData,
  DashboardDokterParams,
  PasienAkanDatangParams,
  PasienAkanDatangResponse,
  RegisterPasienParams,
  RegisterPasienResponse,
  TrenKunjunganDokterData,
  TrenKunjunganParams
} from "@/types/daftarRegisterPasien";

const BASE = "/daftar-register-pasien";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });
}

async function getList(
  params: RegisterPasienParams
): Promise<RegisterPasienResponse> {
  const response = await handle(http.getDataParam(BASE, { params }));

  return response.data;
}

async function getPasienAkanDatang(
  params: PasienAkanDatangParams
): Promise<PasienAkanDatangResponse> {
  const response = await handle(
    http.getDataParam(`${BASE}/akan-datang`, { params })
  );

  return response.data;
}

async function getDashboardDokter(
  params: DashboardDokterParams
): Promise<{ status: number; data: DashboardDokterData }> {
  const response = await handle(
    http.getDataParam(`${BASE}/dashboard-dokter`, { params })
  );

  return response.data;
}

async function getTrenKunjunganDokter(
  params: TrenKunjunganParams
): Promise<{ status: number; data: TrenKunjunganDokterData | null }> {
  const response = await handle(
    http.getDataParam(`${BASE}/dashboard-dokter/tren`, { params })
  );

  return response.data;
}

async function getAsesmenPendingDpjp(
  register: string | number
): Promise<AsesmenPendingDpjpRow[]> {
  const response = await http
    .getData(`/register/${register}/asesmen-keperawatan/pending-dpjp`)
    .catch(() => null);

  const body = response ? response.data : null;

  return body && Array.isArray(body.data) ? body.data : [];
}

export default {
  getList,
  getPasienAkanDatang,
  getDashboardDokter,
  getTrenKunjunganDokter,
  getAsesmenPendingDpjp
};
